import React from 'react';
import { Flex } from '@chakra-ui/react';
import {
  Heading,
  Text,
} from '@ayble-health/dashboard-components';
import { INK, SUBTLE } from './tokens';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const walkIllo: string = require('../../assets/illustrations/walk.png');

type Props = {
  heading: string;
  subhead: string;
};

export const EmptyColumnState = ({ heading, subhead }: Props) => (
  <Flex direction="column" align="center" pt={12} pb={8} px={4}>
    <img src={walkIllo} alt="" style={{ width: '220px', marginBottom: '24px' }} />
    <Heading size="xs" color={INK} textAlign="center" mb={2}>
      {heading}
    </Heading>
    <Text color={SUBTLE} fontSize="sm" textAlign="center" maxW="260px">
      {subhead}
    </Text>
  </Flex>
);
